import uuidv4 from 'uuid/v4';

export function deleteChapterPartTransformation(courses, id) {
    return (
        courses.map((course) => {
            return {...course,
                CourseSubject: course.CourseSubject.map((subject) => {
                    return {
                        ...subject,
                        CourseChapter: subject.CourseChapter.map((chapter) => {
                            return {
                                ...chapter,
                                ChapterVideo: chapter.ChapterVideo.filter((part) => {
                                    return part.id !== id
                                })
                            }

                        })
                    }

                })
            }


        })
    )
}

export function editChapterInformationTransformation(courses, chapterEdit) {
    return (
        courses.map((course) => ({
                id: course.id,
                name: course.name,
                description: course.description,
                items: course.items.map((chapter) => {
                    if (chapter.id === chapterEdit.id) {
                        return {
                            ...chapterEdit
                        }
                    } else {
                        return {...chapter}
                    }
                })
            }
        ))
    )
}

export function addNewChapterTransformation(courses, chapter) {
    let newChapter = {
        id: uuidv4(),
        number: chapter.newChapter.number,
        chapterTitle: chapter.newChapter.chapterTitle,
        description: chapter.newChapter.description,
        parts: []
    };

    return (
        courses.map((item) => {
            item.CourseSubject.map(subject => {
                if(subject.id === chapter.subjectId){
                    return {
                        id: subject.id,
                        name: subject.name,
                        description: subject.description,
                        slug: subject.slug,
                        courseId: subject.courseId,
                        CourseChapter: [
                            ...subject.CourseChapter,
                            chapter.newChapter
                        ]
                    }

                }else{
                    return {
                        ...subject
                    }
                }
            })
            if (item.id === chapter.courseId) {
                return {
                    id: item.id,
                    name: item.name,
                    description: item.description,
                    items: [...item.items, newChapter]
                }
            } else {
                return {
                    ...item
                }
            }

        })
    )
}

export function deleteOneChapterTransformation(courses, id) {
    return (
        courses.map((course) => ({
            id: course.id,
            name: course.name,
            description: course.description,
            items: course.items.filter((item) => item.id !== id)
        }))
    )
}

export function addNewCourseTransformation(courses, newCourse) {
    let course = {
        id: uuidv4(),
        name: newCourse.subjectName,
        description: newCourse.description,
        img: newCourse.img,
        items: []
    };
    courses.push(course);
    return (
        courses
    )
}
export function handleVisibleChangeTransformation(courses, id) {
    return (
        courses.map((course) => ({
            id: course.id,
            name: course.name,
            description: course.description,
            items: course.items.map((chapter) => {
                if (chapter.id === id) {
                    return {
                        id: chapter.id,
                        number: chapter.number,
                        chapterTitle: chapter.chapterTitle,
                        description: chapter.description,
                        parts: [...chapter.parts],
                        visible: !chapter.visible
                    }
                } else {
                    return {...chapter}
                }
            })
        }))
    )
}

export function addVideoQuestionTransformation(chapterPart, question){
    if(chapterPart.VideoQuestions) {
        return chapterPart.VideoQuestions.concat(question);
    }else{
        return [question];
    }
}

export function updateVideoQuestionsTransformation(chapterPart, question){
    return {
        ...chapterPart,
        VideoQuestion: chapterPart.VideoQuestions.map(q => {
            if(q.id == question.id){
                return {...question};
            }else{
                return {...q};
            }
        })
    }

}

export function addQuizQuestionTransformation(chapterPart, question){
    return chapterPart.QuizQuestions.concat(question);
}

export function deleteQuizQuestionTransformation(chapterPart, id){
    let index = -1;
    for(let i = 0; i < chapterPart.QuizQuestions; i++){
        if(chapterPart.QuizQuestions[i].id == id){
            index = i;
        }
    }
    chapterPart.QuizQuestions.splice(index, 1);

    return chapterPart.QuizQuestions;
}

export function updateQuizQuestionTransformation(chapterPart, question){
    return chapterPart.QuizQuestions.map(q => {
        if(q.id == question.id){
            return {...question};
        }else{
            return {...q}
        }
    });
}



// WEBPACK FOOTER //
// ./src/utils/chapterDataTransformation.js